import t from 'react-translate';
import { useContext } from 'react';

import { useSelector } from 'react-redux';
import { getCourseAliases } from 'redux/selectors/course';
import { useAppDispatch } from 'redux/store';
import { setAddingSuggestedComponentSetId } from 'redux/actions/lecture-pages';
import { AiSuggestedComponentSet } from 'redux/schemas/models/ai-course-creation';

import NvIcon from 'shared/components/nv-icon';
import ClickableContainer from 'components/clickable-container';
import ActivityItemHeader from './activity-item-header';
import { ActivitySuggestionContext } from './suggest-activities-modal-content';
import ActivityTitle from './activity-title';
import ActivityInfo from './activity-info';

import { config } from '../../../../../../../config/config.json';

const ActivityItem = (props: { componentSet: AiSuggestedComponentSet }) => {
  const { componentSet } = props;

  const aliases = useSelector((state) => getCourseAliases(state));
  const { addingComponentSetId, addedComponentSetIds } = useSelector(state => state.app.aiSuggestComponent);

  const { openAddToLessons } = useContext(ActivitySuggestionContext);
  const isAdding = addingComponentSetId === componentSet.id;
  const isAdded = addedComponentSetIds.includes(componentSet.id);

  const dispatch = useAppDispatch();

  const handleAddToLessons = () => {
    dispatch(setAddingSuggestedComponentSetId(componentSet.id));
    openAddToLessons();
  };

  return (
    <div className='list-item d-flex px-4 py-5'>
      <ActivityItemHeader type={componentSet.activity.type} />
      <div className='activity-content w-100'>
        <div className='content-header d-flex justify-content-between mb-2 '>
          <ActivityTitle componentSet={componentSet} />
          {(!isAdded && !isAdding) ? (
            <ClickableContainer
              className='d-flex align-items-center p-0 text-nowrap text-primary'
              aria-label={t.LECTURE_PAGES.LHS.NOVO_AI.SUGGEST_ACTIVITIES.ADD_TO_LESSON(aliases.lectureAliases)}
              onClick={handleAddToLessons}
              data-qa={config.pendo.novoAi.suggestActivities.addToLesson}
            >
              <span className='mr-1'>
                {t.LECTURE_PAGES.LHS.NOVO_AI.SUGGEST_ACTIVITIES.ADD_TO_LESSON(aliases.lectureAliases)}
              </span>
              <NvIcon icon='expand' size='xs-smallest' />
            </ClickableContainer>
          ) : (
            <div className='d-flex align-items-center text-nowrap text-success'>
              {isAdded && <NvIcon icon='check' size='xs-smallest' />}
              <span className='ml-1'>
                {isAdding ? t.FORM.ADDING() : t.LECTURE_PAGES.LHS.NOVO_AI.SUGGEST_ACTIVITIES.ADDED()}
              </span>
            </div>
          )}
        </div>
        <ActivityInfo componentSet={componentSet} />
      </div>
    </div>
  );
};

export default ActivityItem;
